import { IRestClientRequestOptions } from '@gem/modules/restClient';
import dateService from '@gem/services/date-service';

export interface IApiError {
  code: number;
  message: string;
}

export interface IApiErrorResponse {
  error: IApiError;
}

const API_ERROR_NAME = 'API_ERROR';

export function isApiErrorResponse(errorResponse: any): errorResponse is IApiErrorResponse {
  return errorResponse?.error && errorResponse?.error?.code && errorResponse?.error?.message;
}

export class ApiError<TData = any> extends Error {
  public readonly name: string = API_ERROR_NAME;
  public readonly time: number = dateService.now().getTime();

  constructor(
    message: string,
    public code: number,
    public requestEndpoint: string,
    public requestOptions: IRestClientRequestOptions<TData>,
    public responseData: IApiErrorResponse | null = null,
    public responseHeaders: Headers | null = null,
    public originalError: Error | null = null
  ) {
    super(message);
  }
}
